import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import AcademicPlanStatusService from "../../../Services/AcademicPlanStatus.service";
const makeSearchArgs = {
    loadOptions: (searchText, options) => {
        return AcademicPlanStatusService.searchAll(searchText);
    },
    label: "name",
    value: "id",
};
export const AcademicPlanStatusSearch = makeSearch(makeSearchArgs);
export const AcademicPlanStatusMultiSearch = makeMultiSearch(makeSearchArgs);
